import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultPlacholderMessages: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'canned-comments.text-area-placeholder.default-placholder-messages-no-translate',
		defaultMessage: 'Add Comment...',
		description: 'default placeholder text for default comment box',
	},
});
